import { useMutation, useQueryClient } from '@tanstack/react-query';
import { jobPositionService } from '../services/jobPosition.service';
import { JobPositionId, CandidateId } from '@/shared/types/branded.types';

interface UseUnlinkCandidateReturn {
  unlinkCandidate: (
    params: { positionId: string; candidateId: string },
    options?: { onSuccess?: () => void; onError?: (error: Error) => void }
  ) => void;
  unlinkCandidateAsync: (params: { positionId: string; candidateId: string }) => Promise<void>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
}

export function useUnlinkCandidate(): UseUnlinkCandidateReturn {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ positionId, candidateId }: { positionId: string; candidateId: string }) =>
      jobPositionService.removeCandidate({
        positionId: JobPositionId(positionId),
        candidateId: CandidateId(candidateId),
      }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['job-position-candidates', variables.positionId],
      });
    },
  });

  return {
    unlinkCandidate: mutation.mutate,
    unlinkCandidateAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
